
import React, { JSX } from 'react'
import { ImageUpload } from 'components/ImageUpload'
import { Dropdown } from 'components/Dropdown'
import { ImageFit } from 'types/api'

const FIT_OPTIONS: Array<{ value: ImageFit, label: string, description: string }> = [
  { value: 'COVER', label: 'Cover', description: 'Fill the area, crop to keep aspect ratio.' },
  { value: 'CONTAIN', label: 'Contain', description: 'Letterbox inside the area without cropping.' },
  { value: 'FILL', label: 'Fill', description: 'Stretch to fit, ignore aspect ratio.' }
]

export const BackgroundImageInput = ({
  url,
  fit,
  onChangeUrl,
  onChangeFit,
  label = 'Background image (optional)',
  helpText
}: {
  url: string
  fit: ImageFit
  onChangeUrl: (next: string) => void
  onChangeFit: (next: ImageFit) => void
  kind?: string
  label?: string | null
  helpText?: string
}): JSX.Element => {
  const fitDescription = FIT_OPTIONS.find((o) => o.value === fit)?.description ?? ''
  return (
    <div className='space-y-3'>
      <ImageUpload
        value={url}
        onChange={onChangeUrl}
        shape='square'
        label={label}
        helpText={helpText ?? 'Renders behind every other element on the overlay. Use transparent colors above to see it.'}
      />
      {url.length > 0 && (
        <div>
          <span className='mb-1.5 block text-xs font-medium uppercase tracking-wider text-dm-text-accent'>
            Image fit
          </span>
          <Dropdown
            value={fit}
            options={FIT_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
            onChange={(v) => onChangeFit(v as ImageFit)}
          />
          <p className='mt-1 text-[11px] text-dm-text-accent'>{fitDescription}</p>
        </div>
      )}
    </div>
  )
}

export const fitToObjectFit = (fit: ImageFit): React.CSSProperties['objectFit'] => {
  switch (fit) {
    case 'COVER': return 'cover'
    case 'CONTAIN': return 'contain'
    case 'FILL': return 'fill'
  }
}
